// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.evJ74lqyA8efqVXus5le{background-color:#000;color:#fff;font-size:14px;border-width:0px;border-radius:4px;padding:3px 16px 3px 16px}.darkmode .evJ74lqyA8efqVXus5le{color:#fff}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tooltipOverride": `evJ74lqyA8efqVXus5le`
};
export default ___CSS_LOADER_EXPORT___;
